export default __webpack_public_path__ + "static/Buchungsjournal-5e6c2f695d5d023a33ed30208011cfae.png";